module.exports = __webpack_public_path__ + "img/dice-3.f44ef2e9.svg";